import React, { useEffect, useState } from 'react';
import { Table } from 'tea-component';
import Loading from '@/pages/intelligence/components/Loading';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import {
  OverviewMetricColumn,
  dauTitle,
  revenueTitle,
  downloadTitle,
} from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/OverviewCloums';
import { sortOverviewTableByMetric } from './sortUtils';
import { getCountryFlag } from '@/pages/home/_config/countries';
import './index.scss';
import FirstRowEdition from '@/pages/intelligence/components/TableComponents/components/FirstRowEdition';
import { useIntl, getLocale } from 'umi';
import { getDetailGameOverviewPath } from '@/pages/intelligence/utils/topchartsUtils';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
import { DateColumns } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/DateCloums';
const { pageable, scrollable } = Table.addons;

const OverviewTable = (props: any) => {
  const {
    eLoading,
    unPublishedAppIdList,
    inactiveAppIdList = [],
    dateType,
    tableList,
    receiveSumFun,
    setAppIdList,
    gameId,
    dataSource,
  } = props;

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const [sortTableData, setSortTableData] = useState(tableList);
  const [pageSortAttr, setPageSortAttr] = useState({
    currentSortValue: 'desc',
    currentSortMetric: 'release_time',
    currentRatioType: 0,
  });
  const { currentSortValue, currentSortMetric, currentRatioType } = pageSortAttr || {};

  useEffect(() => {
    onSortChage({
      sortMetric: pageSortAttr.currentSortMetric,
      sortVal: pageSortAttr.currentSortValue,
      ratioType: pageSortAttr.currentRatioType,
    });
  }, [JSON.stringify(tableList)]);

  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e.ratioType,
    });
    const sortTable = sortOverviewTableByMetric(tableList, e);
    setSortTableData(sortTable.slice(0));
  };

  const getTitleCur = (t: any) => {
    return locale === 'zh-CN' ? t.titleCN : t.title;
  };

  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    const titles = [downloadTitle, dauTitle(dateType), revenueTitle];
    titles.forEach((t) => {
      metricCloums.push(
        OverviewMetricColumn({
          title: getTitleCur(t),
          textContent: t.textContent,
          key: t.key,
          sortMetric: t.key,
          currentSortValue,
          currentSortKey: `${currentSortMetric}_${currentRatioType}`,
          onSortChage,
          width: t.width,
          dataSource,
        }),
      );
    });
    return metricCloums;
  };

  const onClickGame = (cvm: any) => {
    setAppIdList([cvm.game_detail.id]);
    receiveSumFun([cvm.game_detail.id], [cvm.game_detail.platform]);
  };

  return (
    <>
      {eLoading ? (
        <>
          <div
            style={{
              height: 100,
              color: '#444',
            }}
          >
            <Loading />
          </div>
        </>
      ) : (
        <Table
          className="mobile-other-table"
          bordered="all"
          records={sortTableData}
          // records={data}
          columns={[
            {
              key: 'game',
              header: formatMessage({ id: `dbi_game` }),
              width: 280,
              fixed: 'left',
              render: (cvm: any) => {
                const { id, platform, cover, name } = cvm?.game_detail || {};
                const isUnPublished = unPublishedAppIdList?.includes(id);
                const isInactive = inactiveAppIdList?.includes(id);
                return (
                  <ARightClickToJump
                    href={getDetailGameOverviewPath(gameId, 'mobile')}
                    style={{ display: 'inline' }}
                  >
                    <FirstRowEdition
                      name={name}
                      isUnPublished={isUnPublished}
                      isInactive={isInactive}
                      platform={platform}
                      imgSrc={cover}
                      onClick={() => {
                        onClickGame(cvm);
                      }}
                    />
                  </ARightClickToJump>
                );
              },
            },
            {
              key: 'company',
              width: 180,
              header: formatMessage({ id: `dbi_company` }),
              align: 'left',
              render: (cvm) => (
                <div className="company-table">
                  <img
                    src={getCountryFlag(cvm?.game_detail?.company?.country_abbre)}
                    alt="flag"
                    className="company-table-icon"
                  />
                  <span className="company-table-text">{cvm?.game_detail?.company?.name}</span>
                </div>
              ),
            },
            ...getMetricCloums(),
            DateColumns({
              key: 'release_time',
              sortMetric: 'release_time',
              title: formatMessage({ id: `dbi_release_date` }),
              currentSortMetric,
              currentSortValue,
              dateType,
              onSortChage,
              width: 180,
              renderFunction: (cvm) => <div>{cvm?.game_detail?.release_time}</div>,
            }),
          ]}
          addons={[
            pageable({
              stateTextVisible: true,
              pageSizeVisible: sortTableData?.length > 5,
              pageIndexVisible: sortTableData?.length > 5,
              jumpVisible: sortTableData?.length > 5,
              endJumpVisible: sortTableData?.length > 5,
              pageSizeOptions: [5, 10, 15],
            }),
            scrollable({
              //   maxHeight: 580,
              // minWidth: 2500
              //     tHeaderList?.length > 3
              //       ? 220 * tHeaderList?.length + 300
              //       : 'auto',
            }),
          ]}
        />
      )}
    </>
  );
};

export default OverviewTable;
